import { render, staticRenderFns } from "./ContasPagar.vue?vue&type=template&id=0104019a&scoped=true"
import script from "./ContasPagar.vue?vue&type=script&lang=js"
export * from "./ContasPagar.vue?vue&type=script&lang=js"
import style0 from "./ContasPagar.vue?vue&type=style&index=0&id=0104019a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0104019a",
  null
  
)

export default component.exports